import AppRecord from './AppRecord.js'
import APP from '../../../main.js'

import { xirr } from 'node-irr'

const stock_fields = [
  'date',
  'holding',
  'price',
  'price_date',
  'price_type',
  'crncyrate',
  'intacc_loc',
  'intacc',
  'pending_loc',
  'pending',
  'value',
]
const sum_fields = [
  'ret',
  'buy',
  'sell',
  'income',
  'commitment'
]

// const xirr: (inputs: XirrInput[], options?: RootFinderOptions) => { days: number, rate: number }

class Investment extends AppRecord {
  get controller_name(){
    return 'InvestmentsController'
  }
  get investment_returns(){
    return this._irs||[]
  }
  set investment_returns(v){
    this._irs = v;
  }
  // Get only InvestmentRet
  get cashFlowInvestmentReturns(){
    return []
  }
  get investments(){
    return this._investments||[]
  }
  set investments(v){
    this._investments = v
  }
  get entity(){
    return this.constructor.employeeStore.entitiesById.get(this.entity_id)
  }
  get entity_name(){
    if(this.entity){
      return this.entity.name
    } else {
      return null
    }
  }

  get entity_long_name(){
    if(this.entity){
      return this.entity.long_name
    } else {
      return null
    }
  }

  shallDisplay(){
    return (this.value_primary && this.value_primary != 0) || (this.ret_primary && this.ret_primary != 0) || (this.holding_primary && this.holding_primary != 0)
  }
  get is_minor(){
    return true
  }
  compressIrs(){
    false
  }
  constructor(rec){
    super(rec)
  }
  // META PRIOGRAM THIS!
  get delta_bm_primary(){
    return (this.rpct_primary||0)-(this.bm_rpct_primary||0)
  }
  get flat(){
    return [this, this.investments.map(inv => inv.flat)].flat(Infinity)
  }
  get length(){
    return this.flat.length
  }
  get first_date(){
    return (this.investment_returns[0]||{}).date
  }
  get last_date(){
    return (this.investment_returns[this.investment_returns.length-1]||{}).date
  }
  get today(){
    return (new Date).to_s()
  }
  get asset_class_order(){
    return this.constructor.employeeStore.assetClasses.find(ac => ac.name === this.asset_class).id
  }
  // Set sum_ret, crpct, net_value as new columns on investment_returns
  setIrsStatistics(){
    if(this.investment_returns.length > 0){
      var sum_ret = 0
      var cum_prod = 1
      this.investment_returns.map((ir)=>{
        sum_ret += ir.ret
        ir.sum_ret = sum_ret
        ir.net_value = ir.value - sum_ret
        cum_prod = cum_prod * (ir.rpct + 1)
        ir.crpct = cum_prod
      })
    }
  }
  sumOf(items, field){
    return items.map(item => item[field]).reduce((a,b)=>a+b,0)
  }
  productOf(items){
    return items.map(item => item['rpct']).reduce((a,b) => a*(b+1), 1.0) - 1.0
  }

  // VIRTUAL SCOPED ON INVESTMENT_RETURNS
  count_scoped(scope_name){
    let end_date = this.end_date_scoped(scope_name)
    return this.investment_returns.filter(ir => ir.date <= end_date).length
  }
  years_scoped(scope_name){
    let start = new Date(this.first_date)
    let end   = new Date(this.end_date_scoped(scope_name))
    return (end-start)/(1000*60*60*24*365)
  }
  rpct_pa_scoped(scope_name){
    let value = this['rpct_pa_'+scope_name]
    if(value){return value}
    let rpct = this.rpct_scoped(scope_name)
    value = (rpct+1)**(1.0/this.years_scoped(scope_name)) - 1
    this['rpct_pa_' + scope_name] = value
    return value
  }
  ir_scoped(scope_name){
    let item = this["ir_"+scope_name]
    if(item){return item}
    if(this.investment_returns.length===0){return {}}
    let end_date = this.end_date_scoped(scope_name)
    if(end_date >= this.last_date){
      item = this.investment_returns[this.investment_returns.length-1]
      this['ir_' + scope_name] = item
      return item
    }
    let index = this.investment_returns.findIndex(item => item.date > end_date)
    if(index && index > 0){
      item = this.investment_returns[index-1]
    } else {
      item = {}
    }
    this['ir_' + scope_name] = item;
    return item
  }
  previous_ir_scoped(scope_name){
    let item = this["previous_ir_"+scope_name]
    if(item){return item}
    if(this.investment_returns.length===0){return {}}
    let end_date = this.start_date_scoped(scope_name)
    if(end_date > this.last_date){
      item = this.investment_returns[this.investment_returns.length-1]
      this['previous_ir_'+scope_name] = item
      return item
    }
    let index = this.investment_returns.findIndex(item => item.date >= end_date)
    if(index && index > 0){
      item = this.investment_returns[index-1]
    } else {
      item = {}
    }
    this['previous_ir_'+scope_name] = item
    return item
  }
  set_start_date_scoped(scope_name, value){
    let end_date = this.end_date_scoped(scope_name)
    if(value > end_date){
      this["start_date_"+scope_name] = end_date
    } else {
      this["start_date_"+scope_name] = value
    }
    return this["start_date_"+scope_name]
  }
  start_date_scoped(scope_name){
    let date = this["start_date_"+scope_name]
    if(date){return date}
    let end_date = this.end_date_scoped(scope_name)
    date = end_date.substr(0,4)+"-01-01"
    this["start_date_" + scope_name] = date
    return date
  }
  set_end_date_scoped(scope_name, value){
    this['end_date_'+scope_name] = value
    let start_date = this.start_date_scoped(scope_name)
    if(start_date > value){
      this["start_date_" + scope_name] = undefined
      this.start_date_scoped(scope_name)
    }
    return value
  }
  end_date_scoped(scope_name){
    let date = this["end_date_"+scope_name]
    if(date){return date}
    this["end_date_" + scope_name] = this.today
    return this.today
  }
  ir_periodic_scoped(scope_name){
    let end_date = this.end_date_scoped(scope_name)
    let start_date = this.start_date_scoped(scope_name)
    return this.investment_returns.filter(item =>  (item.date >= start_date) && (item.date <= end_date))
  }
  clear_variables_scoped(scope_name){
    [sum_fields, stock_fields, 'rpct', 'alloc'].flat(2).forEach((field)=>{
      this[field+'_'+scope_name] = undefined
      this['previous_'+field+'_'+scope_name] = undefined
    })
    this["ir_"+scope_name] = undefined
    this['previous_ir_'+scope_name] = undefined
    return true
  }
  set_variables_scoped(scope_name){
    var value
    let current = this.ir_periodic_scoped(scope_name)
    sum_fields.forEach((field) => {
      value = this.sumOf(current, field)
      this[field + '_' + scope_name] = value
    })
    stock_fields.forEach((field)=>{
      value = this.ir_scoped(scope_name)[field]
      this[field+'_'+scope_name] = value
      value = this.previous_ir_scoped(scope_name)[field]
      this['previous_'+field+'_'+scope_name] = value
        })
        this['rpct_'+scope_name] = this.productOf(current)
    return true
  }

  // Find and return all cashflow transactions
  cashFlows(date_from, date_to){
    if (this.asset_class == 'Kontant') { return [] }

    date_from.setHours(0, 0, 0, 0)
    date_to.setHours(0, 0, 0, 0)

    if (this.investment_returns.length == 0){
      return []
    }

    const dateFromStringed = date_from.to_s()
    const dateToStringed = date_to.to_s()

    this.recordsIRR = []
    // When calculating IRR on Total, we need to exclude Cash and fees
    if (['TotalInvestment', 'IssueAggregationInvestment'].includes(this.type)){
      if (!this.cf_investment_returns || (this.cf_investment_returns && this.cf_investment_returns?.length === 0)){
        this.constructor.employeeStore.controllers['InvestmentReturnsController']
        this.compressCashFlowIrs()
      }
      this.recordsIRR = this.cf_investment_returns.filter((x) => x.date >= dateFromStringed && x.date <= dateToStringed && (x.income + x.sell - x.buy - (x.pending_change)) != 0 )
    } else if (this.type == 'InvestmentAggregation'){
      // In this case the IRS have been aggregated, and no investment_id is present
      this.recordsIRR = this.investment_returns.filter((x) => x.date >= dateFromStringed && x.date <= dateToStringed && (x.income + x.sell - x.buy - (x.pending_change)) != 0 )
    } else {
      this.recordsIRR = this.investment_returns.filter((x) => x.investment_id == this.id && x.date >= dateFromStringed && x.date <= dateToStringed && (x.income + x.sell - x.buy - (x.pending_change)) != 0 )
    }

    // Calling 'sort' modifies the object, which in this case is a prop. Dont modify props.
    let sortedIRS = []
    if (this.type == 'TotalInvestment'){
      sortedIRS = [...this.cf_investment_returns].sort((a, b) => new Date(b.date) - new Date(a.date));
    } else {
      sortedIRS = [...this.investment_returns].sort((a, b) => new Date(b.date) - new Date(a.date));
    }
    let first_investment = sortedIRS.find((x) => x.date < date_from.to_s())
    if (! first_investment){
      first_investment = sortedIRS.find((x) => x.date == date_from.to_s())
    }
    if (! first_investment){
      // Reverse to get the first in the collection
      first_investment = sortedIRS.toReversed().find((x) => x.date <= date_to.to_s())
    }
    const last_investment = sortedIRS.find((x) => x.date <= date_to.to_s())
    
    if (!first_investment){
      return []
    }

    let cashFlows = []

    let start_date = new Date(this.first_date)
    if (start_date < date_from){
      start_date = date_from
    }
    let end_date = new Date(this.last_date)
    if (date_to < end_date){
      end_date = date_to
    }
    
    // Sum up field refund from all sortedIRS where the date is between date_from and date_to
    let refund = sortedIRS
      .filter((x) => x.date >= date_from.to_s() && x.date <= date_to.to_s())
      .map((x) => Number(x.refund))
      .reduce((a, b) => a + b, 0)

    // Ensure value refund is a number. If Nan or null, set to zero
    if (isNaN(refund) || refund == null){
      refund = 0
    }

    cashFlows.push([start_date, -first_investment.value])
    cashFlows.push([end_date, last_investment.value + refund])
    
    this.recordsIRR.forEach((inv) => {
      let nDate = new Date(inv.date)
      nDate.setHours(0, 0, 0, 0)
      // If the date is on the same day, as the start date, update the value to reflect trade values
      if (nDate.to_s() === first_investment.date){
        cashFlows[0][1] = (inv.income + inv.sell - inv.buy - inv.pending_change)
      } else {
        cashFlows.push([nDate, (inv.income + inv.sell - inv.buy - inv.pending_change)])
      }
    })
    
    cashFlows.sort((a, b) => a[0] - b[0])

    return cashFlows
  }

  get last_xirr_from_date() {
    return this._last_xirr_from_date || null;
  }
  set last_xirr_from_date(value) {
    this._last_xirr_from_date = value;
  }

  get last_xirr_to_date() {
    return this._last_xirr_to_date || null;
  }
  set last_xirr_to_date(value) {
    this._last_xirr_to_date = value;
  }

  get last_xirr() {
    return this._last_xirr || null;
  }
  set last_xirr(value) {
    this._last_xirr = value;
  }

  giveXirr(date_from = null, date_to = null, newWay = false){
    let ret = 0
    let sDate = date_from ? date_from : new Date(this.start_date_scoped('primary'))
    let eDate = date_to ? date_to : new Date(this.end_date_scoped('primary'))

    if (sDate > eDate){ return 0 }

    if (!['InvestmentAggregation', 'IssueAggregationInvestment'].includes(this.type) && sDate.to_s() === this.start_date_scoped('primary') && eDate.to_s() === this.end_date_scoped('primary')){
      return (this.irr_period_primary || 0.0) 
    }

    if (this.last_xirr_from_date && this.last_xirr_to_date && this.last_xirr_from_date.to_s() === sDate.to_s() && this.last_xirr_to_date.to_s() === eDate.to_s()){
      return this.last_xirr
    }

    ret = this.xirr(sDate, eDate, newWay)

    this.last_xirr_from_date = sDate
    this.last_xirr_to_date = eDate
    this.last_xirr = ret

    return ret
  }

  xirr(date_from, date_to, newWay = false){
    date_from.setHours(0, 0, 0, 0)
    date_to.setHours(0, 0, 0, 0)

    const cashFlows = this.cashFlows(date_from, date_to)

    if (cashFlows.length == 0){
      return 0
    }

    const dateToStringed = date_to.to_s()

    // Calling 'sort' modifies the object, which in this case is a prop. Dont modify props.
    // spread-operator copies the contents of the 
    let sortedIRS = []
    if (this.type == 'TotalInvestment'){
      sortedIRS = [...this.cf_investment_returns].sort((a, b) => new Date(b.date) - new Date(a.date));
    } else {
      sortedIRS = [...this.investment_returns].sort((a, b) => new Date(b.date) - new Date(a.date));
    }
    const last_investment = sortedIRS.find((x) => x.date <= date_to.to_s())
    const dates = cashFlows.map(x => x[0]);
    const flows = cashFlows.map(x => Number(x[1]));
    let xirr_raw = this.calculateXIRR(flows, dates, (last_investment.rpct || 0.0));
    if (xirr_raw === 0){
      xirr_raw = this.calculateXIRR(flows, dates, this.rpct_primary);
    }
    let xirr_daily = Math.pow((1 + xirr_raw), (1 / 365.0)) - 1.0

    if (xirr_daily === 0 || newWay){
      const cfs = cashFlows.map((x) => {
        return {
          amount: x[1],
          date: x[0]
        }
      })

      // New way
      let xirr_raw_new_daily = xirr(cfs)

      xirr_daily = xirr_raw_new_daily.rate
    }

    let start_date = cashFlows[0][0]
    let end_date = cashFlows[cashFlows.length - 1][0]

    let normalizedFromDate = new Date(start_date.getFullYear(), start_date.getMonth(), start_date.getDate());
    let normalizedToDate = new Date(end_date.getFullYear(), end_date.getMonth(), end_date.getDate());
    
    // Calculate the difference in milliseconds
    let differenceInMilliseconds = normalizedToDate - normalizedFromDate;

    // Convert milliseconds to days
    let differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);
    const xirr_period = Math.pow((1.0 + xirr_daily), differenceInDays) - 1.0
    
    return xirr_period
  }


  calculateXIRR(cashFlows, dates, guess = 0.1, tolerance = 1.0e-6) {
    if (cashFlows.length !== dates.length) {
      throw new Error('Mismatched number of cash flows and dates');
    }
  
    const maxIterations = 100;
    let x0 = guess;
    let x1 = 0;
  
    for (let i = 0; i < maxIterations; i++) {
      let fValue = 0;
      let fDerivative = 0;
  
      for (let j = 0; j < cashFlows.length; j++) {
        const days = this.daysBetween(dates[0], dates[j]);
        const denominator = Math.pow(1 + x0, days / 365);
        fValue += cashFlows[j] / denominator;
        fDerivative -= (days / 365) * cashFlows[j] / Math.pow(1 + x0, days / 365 + 1);
      }
  
      x1 = x0 - fValue / fDerivative;
  
      if (Math.abs(x1 - x0) < tolerance) {
        return x1;
      }
  
      x0 = x1;
    }
  
    return 0;
  }
  
  daysBetween(date1, date2) {
    // Create new dates with only the year, month, and day components
    let normalizedFromDate = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    let normalizedToDate = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());

    // Calculate the difference in milliseconds
    let differenceInMilliseconds = normalizedToDate - normalizedFromDate;

    // Convert milliseconds to days
    let differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);

    return differenceInDays.round(0)

    // return (date2.getDate() - date1.getDate())
    // const oneDay = 24 * 60 * 60 * 1000;
    // const firstDate = new Date(date1);
    // const secondDate = new Date(date2);
    // return Math.abs((firstDate - secondDate) / oneDay);
  }

  getInvestmentReturns(){
    if(this.investment_returns.length === 0 && this.id){
      this.constructor.employeeStore.GET_INVESTMENT_RETURNS({where: {investment_id: [this.id], date: `..${(new Date).to_s()}`}})
    } else if(this.investment_returns.length === 0 && this.type === 'IssueAggregationInvestment'){
      let inv_ids = this.investments.map(inv => inv.id).filter(v => v)
      this.constructor.employeeStore.GET_INVESTMENT_RETURNS({where: {investment_id: inv_ids, date: `..${(new Date).to_s()}`}}).then(()=>{
        this.compressIrs()
      })
    }
  }
}

export default Investment

// stock_fields.forEach((method)=>{
//   Investment.prototype[method+'_scoped'] = function(scope_name){
//     let value = this.ir_scoped(scope_name)[method]
//     APP.$set(this, method+'_'+scope_name, value)
//     return value
//   }
// })
// stock_fields.forEach((method)=>{
//   Investment.prototype['previous_'+method+'_scoped'] = function(scope_name){
//     let value = this.previous_ir_scoped(scope_name)[method]
//     APP.$set(this, 'previous_'+method+'_'+scope_name, value)
//     return value
//   }
// })
// sum_fields.forEach((method)=>{
//   Investment.prototype[method+'_scoped'] = function(scope_name){
//     let items = this.ir_periodic_scoped(scope_name)
//     let value = this.sumOf(items, method)
//     APP.$set(this, method+'_'+scope_name, value)
//     return value
//   }
// })
